<template>
	<v-layout wrap>
		<v-flex xs3>
			<section-information
				:is-edit="isEdit"
				@change-image="changeImage"
			/>
		</v-flex>
		<v-flex xs9 pl-3>
			<router-view 
				:image-user="imageUser"
				name="profileEdit">
			</router-view>
			<router-view name="passwordEdit"></router-view>
			<form-perfil v-if="isInformation"/>
		</v-flex>
	</v-layout>
</template>
<script>
import sectionInformation from '@/components/user/section-information';
import formPerfil from '@/components/user/form-perfil';

function created() {
	this.isEdit = this.$route.name === 'profile-edit';
	this.isInformation = this.$route.name === 'profile';
}

function $route(value) {
	this.isEdit = value.name === 'profile-edit';
	this.isInformation = value.name === 'profile';
}

function changeImage(url) {
	this.imageUser = url;
}

function data() {
	return {
		isEdit: false,
		imageUser: null,
		isInformation: true,
	};
}

export default {
	name: 'page-user',
	data,
	created,
	components: {
		formPerfil,
		sectionInformation,
	},
	methods: {
		changeImage,
	},
	watch: {
		$route,
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/user/page-user.vue